import { Stack } from '@mui/material'
import styled from 'styled-components'
import { ACCENT_BLUE } from '../../../utils/brand-colors'

export const OrderCardContainer = styled.div<{ $selected?: boolean }>`
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid ${({ $selected }) => ($selected ? ACCENT_BLUE : '#E0E0E0')};
  border-left: 4px solid
    ${({ $selected }) => ($selected ? ACCENT_BLUE : '#BDBDBD')};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
`

export const OrderCardContent = styled.div<{ $selected?: boolean }>`
  padding: 12px 12px 8px;
  background: ${({ $selected }) => ($selected ? '#E8F3FC' : '#ffffff')};
  color: #1a1a1a;
`

export const OrderCardStatus = styled(Stack)`
  padding: 8px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`
